export const displays = {
    block: 'block',
    inline: 'inline',
    subtext: 'inline'
}


// WEBPACK FOOTER //
// ./src/components_new/common/styles.js